import useRequest from './useRequest'

export interface UserProfile {
  id: number
  musedamUserId: string
  userDiscord: {
    discordUserId: string
    discordDiscriminator: string
    discordUsername: string
  }
  userMuseDamToken: {
    accessTokenExpiresAt: string
    refreshTokenExpiresAt: string
  }
  userWeixin?: {
    openId: string
  }
}
export default function useUserProfile(refreshInterval?: number) {
  return useRequest<UserProfile, unknown>(
    { url: `/api/user/profile` },
    {
      refreshInterval: refreshInterval ?? 0,
    },
  )
}
